export function getPaginatedList(data: any[], page: number, limit: number) {
    const offset = (page - 1) * limit;
    const paginatedItems = data.slice(offset, offset + limit);

    return paginatedItems;
}
